<template>
  <div class="d-flex justify-center flex-grow-1 flex-shrink-1" :media-loaded="loaded">
    <video
      v-if="image.isMp4"
      :src="src"
      :style="{
        'max-height': `${maxHeight}px`,
        'max-width': maxWidth ? `${maxWidth}px` : '100%'
      }"
      autoplay
      loop
      muted
      playsinline
      class="fill-width"
      @loadeddata="onLoad"
    />
    <v-img v-else :cover="!contain" :eager="eager" :max-height="maxHeight" :max-width="maxWidth" :src="src" @load="onLoad" />
  </div>
</template>

<script>
import * as images from "@/services/images.js"

export default {
  props: {
    image: {
      type: Object,
      required: true
    },
    viewerWidth: {
      type: Number,
      required: true
    },
    maxHeight: {
      type: Number,
      required: true
    },
    inModal: {
      type: Boolean,
      default: false
    },
    contain: {
      type: Boolean,
      default: false
    },
    eager: {
      type: Boolean,
      default: false
    },
    inactive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //This is used for mutation observer to know when image is loaded inside of container
      loaded: false
    }
  },
  computed: {
    modalViewHorizontalMargins() {
      return !this.$vuetify.display.mobile ? 200 : 0
    },
    version() {
      if (this.image.isMp4 || this.image.isGif) {
        return this.image.versions.original_mp4 || this.image.versions.original
      }
      const widestUncroppedVersion = images.getWidestUncroppedVersion(this.image)

      //Highest not cropped (height_x) image version we can have is 1024px height,
      //if its width is lower than container width then we can assume that
      //it will look blurry so we can switch to cropped version (width_x)
      if (!this.inModal && widestUncroppedVersion.width < this.viewerWidth - 250) {
        const croppedVersion = images.getBestImageVersion(this.image, {
          type: "width",
          minWidth: this.viewerWidth
        })
        if (croppedVersion) {
          return croppedVersion
        }
      }
      return widestUncroppedVersion
    },
    src() {
      if (this.image.isMp4 || this.image.isGif) {
        return this.version?.base_url
      }
      return this.version?.url
    },
    maxWidth() {
      return this.inModal ? window.innerWidth - this.modalViewHorizontalMargins : null
    },
    imageArea() {
      let realHeight = this.maxHeight
      let realWidth = (this.maxHeight / this.version.height) * this.version.width

      //Case when it still needs rescaling (to width this time)
      if (realWidth > this.maxWidth) {
        realWidth = this.maxWidth
        realHeight = Math.ceil((this.maxWidth / this.version.width) * this.version.height)
      }

      const x1 = Math.ceil((window.innerWidth - realWidth) / 2)
      const y1 = Math.ceil((window.innerHeight - realHeight) / 2)

      return {
        x1,
        y1,
        x2: x1 + realWidth,
        y2: y1 + realHeight
      }
    }
  },
  beforeUnmount() {
    if (this.inModal) {
      document.removeEventListener("click", this.onClick)
    }
  },
  methods: {
    onLoad() {
      this.loaded = true
      if (this.inModal) {
        document.addEventListener("click", this.onClick)
      }
    },
    onClick(event) {
      //Prevent closing modal when clicking on buttons
      if (this.inactive || event.target.tagName === "I") {
        return
      }

      if (event.clientX < this.imageArea.x1 || event.clientX > this.imageArea.x2 || event.clientY < this.imageArea.y1 || event.clientY > this.imageArea.y2) {
        this.$emit("modal-outside-image-click")
      }
    }
  }
}
</script>
